import { createSlice } from '@reduxjs/toolkit';

const userSessionSlice = createSlice({
  name: 'usersession',
  initialState: {
    isUserSessionOut: false,
  },
  reducers: {
    setUserSession: (state, action) => {
      state.isUserSessionOut = action.payload;
    },
  },
});

const { actions, reducer } = userSessionSlice;

export const { setUserSession } = actions;

export default reducer;
